{
  "title": "Demiplane",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level conjuration",
  "level": 8,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S",
  "duration": "1 hour",
  "description": [
    "You create a shadowy door on a flat solid surface that you can see within range. The door is large enough to allow Medium creatures to pass through unhindered. When opened, the door leads to a demiplane that appears to be an empty room 30 feet in each dimension, made of wood or stone. When the spell ends, the door disappears, and any creatures or objects inside the demiplane remain trapped there, as the door also disappears from the other side.",
    "Each time you cast this spell, you can create a new demiplane, or have the shadowy door connect to a demiplane you created with a previous casting of this spell. Additionally, if you know the nature and contents of a demiplane created by a casting of this spell by another creature, you can have the shadowy door connect to its demiplane instead."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
